import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=fa0ef228&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=js&"
export * from "./DownloadButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=fa0ef228&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0ef228",
  null
  
)

export default component.exports